var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFeedbackThanks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 675,
    height: 605,
    viewBox: "0 0 675 605",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M665 10H10.0605V595H665V10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5605 594.5V10.5H664.5V594.5H10.5605Z",
    stroke: "#BFBFBF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1211 81H665.061",
    stroke: "#E7E7E7",
    strokeWidth: 2.88649
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M664.454 10.557H10.5142V45.557H664.454V10.557Z",
    fill: "#1E1545"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.112,
    d: "M435.767 97.7455H23.8047V578.745H435.767V97.7455Z",
    fill: "#C6BFC4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.88 462.843H120.892C114.876 462.843 110 457.967 110 451.951V202.106C110 196.091 114.876 191.214 120.892 191.214H554.108C560.124 191.214 565 196.091 565 202.106V451.951C565 457.967 560.124 462.843 554.108 462.843H206.524L191.392 478.019C187.145 482.279 180.259 482.279 176.011 478.019L160.88 462.843Z",
    fill: "#CE0F69"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M401.426 265.894C383.589 250.651 357.32 253.57 340.78 270.434L334.618 276.92L328.132 270.434C311.916 253.57 285.323 250.651 267.486 265.894C247.054 283.406 246.081 314.54 264.243 333.35L327.159 398.212C331.051 402.428 337.861 402.428 341.753 398.212L404.669 333.35C422.83 314.54 421.858 283.406 401.426 265.894Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.0605469,
    y: 0,
    width: 674.939,
    height: 605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFeedbackThanks);
export default __webpack_public_path__ + "static/media/user-feedback-thanks.bf7d580e598b39586023ca8179f2b576.svg";
export { ForwardRef as ReactComponent };